import React, { Component } from 'react'
import classes from 'classnames'
import { Row, Col } from 'react-bootstrap'

import '../../../../assets/sass/pages/payment/components/selected-plan-card.scss';
import PlanIcon from '../../../ui/plans/PlanIcon';

class SelectedPlanCard extends Component {
    static defaultProps = {
        plan: 'platinum',
        text: 'Platinum plan provides access to all features and videos',
        price: 600
    }

    render() {
        const { plan, text, price } = this.props;

        return (
            <div className={classes("selected-plan-card", plan, `gradient-${plan}`)}>
                <Row>
                    <Col md={9}>
                        <PlanIcon plan={plan} />
                        <h6 className="selected-plan-card--title">{plan}</h6>
                        <p className="selected-plan-card--text">{text}</p>
                    </Col>
                    <Col md={3}>
                        <div className="selected-plan-card--price">${price}</div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default SelectedPlanCard